<script lang="ts">
    import type { SvelteComponent } from "svelte"
    import type { HTMLElement } from "node-html-parser"

    export let nodes: HTMLElement[]
    export let tags: { [key: string]: typeof SvelteComponent } = {}
    export let additionalProps: { [key: string]: any } = {}

    const ELEMENT_NODE = 1
    const TEXT_NODE = 3
</script>

{#each nodes as node (node)}
    {#if node.nodeType == TEXT_NODE}{node.textContent}{:else if node.nodeType == ELEMENT_NODE}
        {#if tags[node.rawTagName]}
            <svelte:component
                this="{tags[node.rawTagName]}"
                {...node.attributes}
                {...additionalProps}
                ><svelte:self
                    nodes="{node.childNodes}"
                    tags="{tags}"
                    additionalProps="{additionalProps}"
                /></svelte:component
            >
        {:else}
            <svelte:element this="{node.rawTagName}" {...node.attributes}
                ><svelte:self
                    nodes="{node.childNodes}"
                    tags="{tags}"
                    additionalProps="{additionalProps}"
                /></svelte:element
            >
        {/if}
    {/if}
{/each}
